module.exports = __webpack_public_path__ + "img/upload.f0e1015e.svg";